//  @include('modals.attachments-modal')
//     @include('modals.invite-suppliers-modal')
//     @include('modals.no-comercial-proposal-modal')
//     @include('modals.no-proposals-sent-modal')
//     @include('modals.recipient-contact-modal')
//     @include('modals.revision-message-modal')
//     @include('modals.supplier-contact-modal') - OK
//     @include('modals.supplier-no-proposal-status-error-modal')
//     @include('modals.supplier-proposal-sent-status-error-modal')
//     @include('modals.update-invite-email-modal')
//     @include('modals.public-documents-modal')
//     @include('modals.request-public-documents-modal')
//     @include('modals.request-public-documents-success-modal')
//     @include('modals.request-additional-public-documents-modal')
import HeaderProposals from '@/components/contractor/competitions/proposals/header/Header.vue';
import TableProposals from '@/components/contractor/competitions/proposals/table/Table.vue';
import Participants from '@/components/contractor/competitions/proposals/participants/Participants.vue';
import SupplierContact from '@/components/contractor/competitions/proposals/modals/supplier-contact';
import UpdateInvitationEmail from '@/components/contractor/competitions/proposals/modals/update-invitation-email';
import {
    getCompetitionData,
    toggleInvitations,
    toggleProposals,
    getSupplierContact,
    getSupplierContactByEmail,
    getParticipants
} from '@/services';
export default {
    name: 'CompetitionProposals',
    components: { HeaderProposals, TableProposals, SupplierContact, UpdateInvitationEmail, Participants },
    data: () => ({
        id: 'teste',
        competitionData: {},
        proposals: [],
        checkbox: {
            proposals: [],
            suppliers: []
        },
        supplierConcat: {},
        modalSupplierConcat: false,
        noProposalsSent: false,
        modalUpdateInvitationEmail: false,
        suppliers: []
    }),
    methods: {
        updateInvitationEmail(supplier) {
            this.supplierConcat = supplier;
            this.modalUpdateInvitationEmail = true;
        },
        async getSupplierContact({ supplier }) {
            let data;
            if (supplier.id) data = await getSupplierContact(supplier.id);
            else data = await getSupplierContactByEmail(supplier.email);
            if (data) this.supplierConcat = data.supplier;
            else {
                this.supplierConcat = supplier;
            }
            this.modalSupplierConcat = true;
        },
        async toggleSuppliers() {
            if ((await this.toggleProposals()) || (await this.toggleInvitations())) {
                window.location.reload();
            }
        },
        async toggleProposals() {
            if (this.checkbox.proposals.length) {
                const data = {
                    proposals: this.checkbox.proposals
                };
                await toggleProposals(data);
                return true;
            } else {
                return false;
            }
        },
        async toggleInvitations() {
            if (this.checkbox.suppliers.length) {
                const tokens = this.checkbox.suppliers.map(({ token }) => token);
                console.log(this.checkbox.suppliers);
                const data = {
                    competition_id: this.competitionData.id,
                    tokens
                };
                console.log(data);
                await toggleInvitations(data);
                return true;
            } else {
                return false;
            }
        },
        async suppliersParticipating(id) {
            const data = await getParticipants(id)
            this.suppliers = data
        }
    },
    async created() {
        this.id = this.$route.params.id;
        await this.suppliersParticipating(this.id)
        const { data } = await getCompetitionData(this.id);
        this.competitionData = data;
    }
};
